import { useSearchParams } from "react-router-dom";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Messenger } from "../../components/Messenger/Messenger";
import { ReduxState } from "../../redux/store";
import { env } from "../../env";
import { Online } from "../Online/Online";

import "./Chat.scss";

export const Chat = () => {
    const {params} = useSelector(({page}: ReduxState) => page);
    const [searchParams] = useSearchParams();
    
    const [userId] = useState<string | null>(params?.userId ?? searchParams.get('userId'));
    const [roomId] = useState<string | null>(params?.externalRoomId ?? searchParams.get('roomId'));
    const [sessionId] = useState<string | null>(params?.sessionId ?? searchParams.get('sessionId'));
    const [serviceType] = useState<string | null>(params?.serviceType ?? env().REACT_APP_SERVICE_TYPE);
    const [isContacts, setIsContacts] = useState<boolean>(params?.showContacts ?? false);
    const fullChatMode = !roomId && env().REACT_APP_FULL_CHAT && env().REACT_APP_USE_TM_AUTH;
    const contextUrl = params?.contextUrl ?? env().REACT_APP_CONTEXT_URL;
    
    const changePage = (tab: any) => {
        setIsContacts(tab === 'contacts');
    }
    
    return <div className="chat-container">
        {fullChatMode && <Online inChat={true} />}
        <Messenger changePage={changePage} fullChatMode={fullChatMode} contextUrl={contextUrl} contactsMode={isContacts} visible={true} fullMode={true} userId={userId} externalRoomId={roomId} link={params?.link} showChatsList={params?.showChats} authSessionId={sessionId} serviceType={serviceType}/>
    </div>
}
